import get from 'lodash/get'

export default function Tooltip(event, settings, tipData = null) {
    const tip = settings.toolTip.current

    if (tipData) {
        let x
        let y
        const eventData = get(event, 'currentTarget.cx')
        if (eventData) {
            x = event.currentTarget.cx.baseVal.value + 5
            y = event.currentTarget.cy.baseVal.value
        } else {
            x = event.currentTarget.transform.baseVal[0].matrix.e + 5
            y = event.currentTarget.transform.baseVal[0].matrix.f
        }

        tip.innerHTML = `
        <foreignObject x=${x} y=${y} width=${settings.vizWidth / 2} height=${
            settings.vizHeight / 2
        }>
                <div class="evp-svg-tooltip">
                ${tipData}
                </div>
        </foreignObject>
        `
    } else {
        tip.innerHTML = null
    }
}
